import React from 'react';

const SpinnerLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    className="animate-spin w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 lg:w-48 lg:h-48"
    aria-label="Loading spinner"
    role="img"
  >
    <circle
      cx="50"
      cy="50"
      r="40"
      fill="none"
      stroke="#e0e0e0" // Light gray background circle
      strokeWidth="4"
      opacity="0.3"
    />
    <circle
      cx="50"
      cy="50"
      r="40"
      fill="none"
      stroke="url(#gradient)"
      strokeWidth="5"
      strokeLinecap="round"
      strokeDasharray="150" // Length of the stroke
      strokeDashoffset="75" // Controls how much of the stroke is visible
      className="transition-all duration-700 ease-in-out"
    />
    <defs>
      <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#3b82f6" /> {/* Tailwind Blue-500 */}
        <stop offset="100%" stopColor="#1d4ed8" /> {/* Darker Blue */}
      </linearGradient>
    </defs>
    <text
      x="50%"
      y="50%"
      textAnchor="middle"
      dominantBaseline="middle"
      fill="#1d4ed8" // Text color
      fontSize="10" // Adjusted font size
      fontWeight="bold"
      fontFamily="'Arial', sans-serif" // Font family
      letterSpacing="1px" // Added letter spacing
      style={{ textShadow: '1px 1px 2px rgba(0, 0, 0, 0.3)' }} // Text shadow for depth
    >
    </text>
  </svg>
);
export default SpinnerLogo;

